module.exports = __webpack_public_path__ + "static/media/Municipal-Active-and-Safe-Travel-Policie.cba05915.pdf";